import {  Table } from "reactstrap";
import { H6 } from "../../../AbstractElements";
import { useTranslation } from "react-i18next";


const ProjectDetails = ({ item }: any) => {
  const {t}=useTranslation()
  return (
    <td>
    <Table className="bill-content w-100">
      <tbody>
      <tr>
    
          <td style={{ width: "21%" }}>
            <span style={{ opacity: "0.8" ,color:"#757272"}}>{t("OrganizationCountry")}</span>
            <H6 style={{ width: "46%" }}>
              {item?.country? item?.country : "N/A"} 
            </H6>
          </td>
          <td style={{ width: "21%" }}>
            <span style={{ opacity: "0.8",color:"#757272" }}>{t("OrganizationCity")}</span>
            <H6>{item.city? item.city : "N/A"}</H6>
          </td>
          <td style={{ width: "36%" }}>
            <span style={{ opacity: "0.8" ,color:"#757272"}}>{t("OrganizationIndustry")}</span>
            <H6>{item.industry? item.industry : "N/A"}</H6>
          </td>
          <td >
            <span style={{ opacity: "0.8" ,color:"#757272"}}>{t("Authority")}</span>
            <H6>{item.authority? item.authority : "N/A"}</H6>
          </td>
          
          {/* <td>
            <span style={{ opacity: "0.8",color:"#757272" }}>{OrganizationWebsite}</span>
            <H6>{item.website? item.website : "N/A"}</H6>
           
          </td> */}
         
        </tr>
        
       
      </tbody>
    </Table>
  </td>

  );
};

export default ProjectDetails;
